module.exports = __webpack_public_path__ + "img/Kürbisschnitzen2022.fed02ddb.jpg";